import React, { useState } from "react";

const Confirm = ({ onConfirm }) => {
  return (
    <>
      <div className="modal fixed w-full h-full top-0 left-64 flex items-center justify-center overflow-auto overlay">
        <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
        <div className="modal-overlay absolute w-500 h-200  opacity-100 p-4 rounded-xl shadow bg-gray-50 mr-64">
          <div>
            <p className="p-10 font-bold text-xl">Zebra Browser Print service is not installed or running on this device.</p>
            <p className="font-bold text-lg text-center">You can download it here:
              <span className="ml-6 text-info underline">
                <a
                  href="https://www.zebra.com/us/en/support-downloads/printer-software/by-request-software.html"
                  target="_blank"
                >
                &lt;Link - Zebra Browser Print&gt;
                </a>
              </span>
            </p>
          </div>
          <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-center mt-4">
            <button
              className="alert alert-info mr-2  font-poppins px-3 py-2 rounded-xl hover:bg-green-500 inline-flex items-center gap-4 shadow-md"
              onClick={onConfirm}
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Confirm;
